import { useState, useEffect } from 'react';

// Données de test pour les notifications
const mockNotifications = [
  {
    id: 1,
    title: "Nouvel événement créé",
    message: "L'événement 'Festival de musique' a été créé avec succès par l'organisateur principal.",
    time: "Il y a 5 minutes",
    read: false,
    type: "success"
  },
  {
    id: 2,
    title: "Mise à jour importante",
    message: "Une nouvelle version de la plateforme est disponible. Veuillez rafraîchir votre page.",
    time: "Il y a 30 minutes",
    read: false,
    type: "info"
  },
  {
    id: 3,
    title: "Attention requise",
    message: "Certains événements nécessitent une validation de votre part.",
    time: "Il y a 1 heure",
    read: false,
    type: "warning"
  },
  {
    id: 4,
    title: "Nouveau sponsor",
    message: "L'entreprise 'TechCorp' a rejoint la plateforme en tant que sponsor principal.",
    time: "Il y a 2 heures",
    read: true,
    type: "success"
  },
  {
    id: 5,
    title: "Maintenance planifiée",
    message: "Une maintenance est prévue ce soir à 23h00. La plateforme sera indisponible pendant 1 heure.",
    time: "Il y a 3 heures",
    read: true,
    type: "info"
  }
];

const useNotifications = () => {
  const [notifications, setNotifications] = useState(mockNotifications);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const count = notifications.filter(notif => !notif.read).length;
    setUnreadCount(count);
  }, [notifications]);

  const markAsRead = (notificationId) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif.id === notificationId 
          ? { ...notif, read: true }
          : notif
      )
    );
  };

  const markAllAsRead = () => {
    setNotifications(prev => 
      prev.map(notif => ({ ...notif, read: true }))
    );
  };

  const addNotification = (notification) => {
    const newNotification = {
      id: Date.now(),
      time: "À l'instant",
      read: false,
      ...notification
    };
    setNotifications(prev => [newNotification, ...prev]);
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  const deleteNotification = (notificationId) => {
    setNotifications(prev => prev.filter(notif => notif.id !== notificationId));
  };

  return {
    notifications,
    unreadCount,
    markAsRead,
    markAllAsRead,
    addNotification,
    clearNotifications,
    deleteNotification
  };
};

export default useNotifications; 